import type { GameDescriptor } from '@everyturn/engine/runtime';

export const shuffleDemoDescriptor = {
  gameId: 'shuffle-demo',
  displayName: 'Shuffle Demo',
  seats: ['south'],
  minPlayers: 1,
  maxPlayers: 1,
  defaultSeat: 'south',
} as const satisfies GameDescriptor;
